import React from 'react';
import MilestoneIntCard from './MilestoneIntCard/MilestoneIntCard';
import './MilestoneInt.css';
import PageTopHeader from "../PageTopHeader/PageTopHeader";

function MilestoneInt(props) {
	const { data, swipeActions } = props;
	const award = data?.mileStones?.mileStoneData[0];
	const activeMilestone = data?.mileStones?.mileStoneData?.findIndex(e => e.isCurrentlyActive === 1) >= 0 ? data?.mileStones?.mileStoneData?.findIndex(e => e.isCurrentlyActive === 1) : data?.mileStones?.mileStoneData.length -2 ;
    const getReadableState = (obj)=> {
      if(obj.percentage >=0 && obj?.isCurrentlyActive === 1) {
        return "ongoing"
      }
      else if(obj.isComplete && obj.percentage === 100) {
        return "complete"
      }
      else if(obj.isWinning === 0 && obj.isCurrentlyActive === 0) {
        return "notStarted";
      }
    }

	return (
        <>
            <div className="page-content page-content-mile-stone">
                <hr className="mile-stone-page-divider" />
                <div className="mile-stone-page-header">
                    <h2>{data?.mileStones.heading}</h2>
                    <p>{data?.mileStones.subHeading}</p>
                </div>
                <div className="mile-stone-card-grpups">
                    <div className="mileStoneCardGroup">
                        {data?.mileStones?.mileStoneData?.map((item,index)=>{
                            return(
                                <MilestoneIntCard
                                    mileStoneData={item}
                                    index={index}
                                    key={index}
                                    activeMilestone={activeMilestone}
                                    activeState={getReadableState(item)}/>
                            )
                        })}
                    </div>
                </div>
                <div className="mile-stone-bottom-img">
                    <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/aug-15-overview-bottom-img.png" alt="overviewbottomimg" />
                </div>
            </div>
        </>
	);
}

export default MilestoneInt;
